import React from 'react';
import PropTypes from 'prop-types';
import { HideOnMobile } from '@web/atoms';
import { PromoPill } from '@web/molecules';
import { CHECKOUT_STEPS } from '../CheckoutHeader/constants';
import { CheckoutHeader } from '../CheckoutHeader';

export const Header = ({
  step,
  checkoutSteps = CHECKOUT_STEPS,
  showLogo,
  showSteps,
}) => {
  const rightHeaderSegment = (
    <HideOnMobile>
      <PromoPill />
    </HideOnMobile>
  );

  return (
    <CheckoutHeader
      showLogo={showLogo}
      showSteps={showSteps}
      currentStep={checkoutSteps[step]}
      rightSegment={rightHeaderSegment}
      steps={checkoutSteps}
    />
  );
};

Header.propTypes = {
  checkoutSteps: PropTypes.array,
  step: PropTypes.number.isRequired,
  showLogo: PropTypes.bool,
  showSteps: PropTypes.bool,
};
